export enum AcquireMethod {
    PURCHASE,
    PRODUCE,
}
